import percentRound from 'percent-round';
import { Partner } from 'types';

export const getPartnersPercentages = (
  partners: Partner[],
  totalShares: number,
  decimalScale = 2
) => {
  const percentages = partners.map((partner) =>
    totalShares ? ((partner?.sharesCount?.actual || 0) * 100) / totalShares : 0
  );

  const roundPercents = percentRound(percentages, decimalScale);

  const result = partners.reduce(
    (acc: Record<string, number>, partner, index) => {
      const partnerId = partner['_id'];
      acc[partnerId] = roundPercents[index];
      return acc;
    },
    {}
  );
  return result;
};
